import {BaSeButton, BaSeGrid, BaSeGridItem} from "@base/react"
import {useEffect, useState} from "react"
import {eventTag, getToken} from "../../services/utils"
import ApiAuth, {redirectToKeycloak} from "../../services/auth"
import Loading from "../../components/loading"
import highlightMobile from "../../assets/images/auth/banner-mobile.jpg"
import highlight from "../../assets/images/auth/banner.jpg"
import logo from "../../assets/images/auth/logo-banner.png"
import mockup from "../../assets/images/auth/mockup-phone.png"
import fampe from "../../assets/images/auth/banner-fampe.jpg"
import icon from "../../assets/images/auth/icon-contents.png"
import CardProjected from "../../components/cards/card-projected"
import Slider from "react-slick"
import {clearCompaniesCache, setCompaniesCache} from "../../services/companiesCache"
import "./index.scss"

const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
}
const dataCards = [
  {
    title: `Preencha seus dados financeiros e acompanhe indicadores essenciais`,
    description: `Inclua informações como Vendas, Movimentações Bancárias, Prazos de Pagamento e Recebimento.<br/><br/>Visualize automaticamente indicadores como rentabilidade e lucratividade, com base nas informações preenchidas.`,
  },
  {
    title: `Projete seu Fluxo de Caixa e planeje suas finanças com mais segurança`,
    description: `Inclua dados como saldo em caixa, investimentos realizados, financiamentos e dívidas.<br/><br/>Assim, será possível realizar uma previsão mais precisa do futuro financeiro da sua empresa, garantindo uma gestão eficiente e estratégica.`,
  },
  {
    title: `Ganhe segurança para formalizar seu negócio ou buscar crédito`,
    description: `Estabeleça uma meta para cumprir o seu planejamento.<br/><br/>E tenha em mãos um documento com a visão estratégica e organizada para avançar com confiança.`,
  },
]

const event = {
  name: "home",
  category: "home",
  action: "click",
}
const api = ApiAuth()

const Auth = () => {
  const [loading, setLoading] = useState(false)

  const userAgent = navigator.userAgent

  const isMobile =
    /Mobile|Android|iP(hone|od|ad)|IEMobile|BlackBerry|Opera Mini/i.test(
      userAgent
    )
  const device = isMobile ? "Mobile" : "Desktop"

  let browser = "Unknown"
  if (userAgent.indexOf("Firefox") > -1) {
    browser = "Firefox"
  } else if (
    userAgent.indexOf("Chrome") > -1 &&
    userAgent.indexOf("Edg") === -1
  ) {
    browser = "Chrome"
  } else if (
    userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") === -1
  ) {
    browser = "Safari"
  } else if (userAgent.indexOf("Edg") > -1) {
    browser = "Edge"
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    browser = "Opera"
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident") > -1
  ) {
    browser = "Internet Explorer"
  }

  const ButtonTemplate = ({ textButton = "Acessar" }) => (
    <BaSeButton
      buttonType="button"
      onClick={() => {
        redirectToKeycloak()
        eventTag("click-button", event?.category, event?.action, textButton)
      }}
      size="medium"
      value={textButton}
      width="100%"
      color="#9285F9"
      isBold={true}
    />
  )
  const getCompanies = () => {
    let hasCompanies = false
    setLoading(true)

    api.getCompanies()
      .then((res) => {
        let { data } = res

        const newData = data.company_list.map((item) => {
          return {
            ...item,
            isActive: !!item.getCurrentCNPJ,
          }
        })
        hasCompanies = data.company_list.length > 0
        setCompaniesCache(newData)
      })
      .catch((err) => {
        console.warn(err)
        clearCompaniesCache()
        setLoading(false)
      })
      .finally(() => {
        const hasPendingSharedToken = sessionStorage.getItem('pendingSharedToken');

        let callbackUrlReturn = sessionStorage.getItem('callbackUrlReturn') || '/planejadora'
        if (callbackUrlReturn && hasCompanies && (callbackUrlReturn.includes('/inicio') || callbackUrlReturn.includes('/planejamento'))) {
          callbackUrlReturn = '/planejadora'
        }

        if (hasPendingSharedToken) {
          callbackUrlReturn = '/planejadora'
        }

        window.location.href = callbackUrlReturn
        sessionStorage.removeItem('callbackUrlReturn')
      })
  }
  const registerLogin = (token) => {
    setLoading(true)
    clearCompaniesCache()
    api.registerLogin(token, device, browser)
      .then((res) => {
        const {status} = res
        if (res) {
          if (status !== 500) {
            localStorage.setItem("onboarding", JSON.parse("true"))
            getCompanies()
          } else {
            console.warn(res)
            window.location.href = '/erro-sistema'
          }
        }
      })
      .catch((error) => {
        console.error("ERROR: ", error)
        if (error.status === 400) {
          window.location.href = "/planejadora"
        } else {
          setLoading(false)
        }
      })
  }
  const TemplateCards = () => {
    const data = dataCards.map((item, k) => (
      <CardProjected key={k}>
        <h2>{item.title}</h2>
        <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
      </CardProjected>
    ))
    return (
      <>
        <div className="carousel mobile">
          <Slider {...sliderSettings}>{data}</Slider>
        </div>
        <div className="carousel desktop">{data}</div>
      </>
    )
  }

  useEffect(() => {
    const token = getToken()
    const params = new URLSearchParams(window.location.hash.split("#")[1])
    const code = params.get("code")

    if (code && !token) {
      api.login(code)
        .then((res) => {
          const {access_token} = res
          registerLogin(access_token)
        })
        .catch((err) => console.warn(err))
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="auth">
      {loading ? (
        <Loading fullPage={true} />
      ) : (
        <div className="content">
          <section className="highlight">
            <picture className="highlight__img">
              <source media="(min-width: 768px)" srcSet={highlight} />
              <img
                src={highlightMobile} alt="Banner" />
            </picture>
            <div className="internal-call-for-access">
              <figure className="logo">
                <img
                  loading="lazy"
                  src={logo}
                  alt="Planejadora Sebrae"
                  title="Planejadora Sebrae"
                />
              </figure>
              <h2 className="internal-call-for-access__text">
                Planeje as finanças da <strong>sua empresa</strong> de forma{" "}
                <strong>simples e inteligente</strong>.
              </h2>
              <ButtonTemplate />
            </div>
            <figure className="highlight__logo">
              <img
                loading="lazy"
                src={logo}
                alt="Planejadora Sebrae"
                title="Planejadora Sebrae"
              />
            </figure>
          </section>
          <section className="call-for-access">
            <div className="container">
              <BaSeGrid>
                <BaSeGridItem
                  tablet={{
                    size: 7,
                    startAt: undefined,
                  }}
                  desktop={{
                    size: 8,
                    startAt: undefined,
                  }}
                >
                  <h2>
                    Planeje as finanças da <strong>sua empresa</strong> de forma{" "}
                    <strong>simples e inteligente</strong>.
                  </h2>
                </BaSeGridItem>
                <BaSeGridItem
                  tablet={{
                    size: 5,
                    startAt: undefined,
                  }}
                  desktop={{
                    size: 4,
                    startAt: undefined,
                  }}
                >
                  <ButtonTemplate />
                </BaSeGridItem>
              </BaSeGrid>
            </div>
          </section>
          <section className="mockup-finances">
            <div className="container">
              <h3 className="title-section">
                Transforme suas finanças e cresça com seu negócio
              </h3>
              <div className="info-mockup">
                <div className="info-mockup__text-area">
                  <h2>Transforme suas finanças e cresça com seu negócio</h2>
                  <p>
                    A Planejadora Financeira do Sebrae é o ponto de partida para
                    buscar crédito com clareza e confiança.
                  </p>
                </div>
                <figure>
                  <img src={mockup} alt="Minha empresa" />
                </figure>
              </div>
            </div>
          </section>
          <section className="wrapper-cards">
            <div className="container">
              <h3 className="title-section">
                Veja tudo o que está ao seu alcance
              </h3>
              <div className="carousel">
                <TemplateCards />
              </div>
              <div className="wrapper-fampe">
                <div className="fampe">
                  <figure>
                    <img
                      loading="lazy"
                      src={fampe} alt="fampe" />
                  </figure>
                  <div className="text">
                    <p>
                      Ou, se precisa de empréstimo, mas não consegue por falta
                      de garantia, faça uma <strong>Simulação do FAMPE</strong>{" "}
                      - Fundo de aval para os pequenos negócios
                    </p>
                    <p className="mb-0">
                      Se quiser saber mais, confira os detalhes no{" "}
                      <strong>
                        <a
                          href="https://www.sebrae.com.br/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => eventTag("click-button", event?.category, event?.action, "Portal Sebrae")}
                        >
                          Portal Sebrae
                        </a>
                      </strong>{" "}
                      ou{" "}
                      <strong>
                        <button
                          className="link"
                          onClick={() => {
                            redirectToKeycloak()
                            eventTag("click-button", event?.category, event?.action, "Acesse a Planejadora")
                          }}
                        >
                          Acesse a Planejadora
                        </button>
                      </strong>
                      .
                    </p>
                  </div>
                </div>
                <div className="wrapper-learn-more">
                  <div className="learn-more">
                    <div className="content">
                      <figure>
                        <img
                          loading="lazy"
                          src={icon} alt="E mais" />
                      </figure>
                      <div className="text">
                        <h4>E mais:</h4>
                        <p>
                          Tenha acesso a conteúdos <br />
                          relevantes e personalizados, <br />
                          com dicas e orientações práticas baseados no perfil da
                          sua empresa e na etapa em que você está.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="wrapper-button-fixed auth">
            <p>Comece agora – é gratuito e leva poucos minutos!</p>
            <ButtonTemplate textButton="Acessar Planejadora Sebrae" />
          </div>
        </div>
      )}
    </div>
  )
}

export default Auth;
